<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer005">
<p class="TOC_Contents"><span epub:type="pagebreak" id="pageix" title="ix"></span></p>
<p class="TOC_1toc" id="_idParaDest-3">Contents<a id="_idTextAnchor000"></a></p>
<p class="TOC_chpt2"><a href="#/Exer#_idTextAnchor001">Exercises</a> </p>
<p class="TOC_chpt"><span class="TOC-num">Chapter One:</span> <a href="#/WFI#_idTextAnchor003">What is the Way of Fire &amp; Ice?</a> </p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Two:</span> <a href="#/WFI1#_idTextAnchor006">The Norse Pagan World</a> </p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Three:</span> <a href="#/WFI2#_idTextAnchor011">The Norse Gods</a> </p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Four:</span> <a href="#/WFI3#_idTextAnchor014">Developing Spiritual Practice</a></p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Five:</span> <a href="#/WFI4#_idTextAnchor018">Core Values</a></p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Six :</span> <a href="#/WFI5#_idTextAnchor021">Runelore</a> </p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Seven:</span> <a href="#/WFI6#_idTextAnchor028">The Art of Seiðr</a> </p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Eight:</span> <a href="#/WFI7#_idTextAnchor031">Finding Community</a> </p>
<p class="TOC_chpt"><span class="TOC-num">Chapter Nine:</span> <a href="#/WFI8#_idTextAnchor036">Building Community</a> </p>
<p class="TOC_chpt2"><a href="#/WFI9#_idTextAnchor038">Afterword</a> </p>
<p class="TOC_chpt2">Appendix I: <a href="#/WFI10#_idTextAnchor041">Further Reading</a> </p>
<p class="TOC_chpt2">Appendix II:  <a href="#/WFI11#_idTextAnchor043">The Origins of the Pagan Revival</a> </p>
<p class="TOC_chpt2"><a href="#/WFI12#_idTextAnchor044">Bibliography</a> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?762986fe